import { combineReducers } from "redux";

import itemReducer from "../modules/dashboard/reducers/itemReducer";
import vendorReducer from "../modules/dashboard/reducers/vendorReducer";
import regulationReducer from "../modules/master/regulation/reducers/regulationReducer";
import searchEngineReducer from "../modules/searchEngine/reducers/searchEngineReducer";
import alertReducer from "../shared-components/alerts/reducers/alertReducer";
import loaderIndicatorReducer from "../shared-components/page-loader-indicators/reducers/loaderIndicatorReducer";

const rootReducer = combineReducers({
  itemReducer: itemReducer,
  vendorReducer: vendorReducer,
  searchEngineReducer: searchEngineReducer,
  alertReducer: alertReducer,
  loaderIndicatorReducer: loaderIndicatorReducer,
  regulationReducer:regulationReducer
});

export default rootReducer;
